<div class="relative mt-8 flex flex-auto flex-col items-center gap-6">
  <div class="flex w-full max-w-3xl flex-col gap-4">
    @if (!attempts() || attempts().length === 0) {
      <div
        class="surface-default flex flex-col items-center justify-center gap-2 rounded-xl border border-neutral-5 p-12 text-center text-neutral-10"
      >
        <mat-icon class="text-3xl text-neutral-8">history</mat-icon>
        <span class="text-base font-medium">Aucune tentative d'envoi enregistrée</span>
      </div>
    } @else {
      @for (attempt of attempts(); track $index; let idx = $index) {
        <div
          class="surface-default flex flex-col gap-4 rounded-xl border border-neutral-5 p-5 shadow-xs transition-all"
        >
          <!-- Card Header -->
          <div class="flex flex-wrap items-center justify-between gap-3">
            <div class="flex flex-wrap items-center gap-2.5">
              <span class="rounded-md bg-neutral-a3 px-2 py-0.5 text-xs font-semibold text-neutral-11">
                #{{ attempts().length - idx }}
              </span>

              <!-- Status badge -->
              <div
                class="inline-flex items-center gap-1.5 rounded-full px-2.5 py-0.5 text-xs font-semibold"
                [class.bg-green-3]="attempt.status === emailAttemptStatus.SUCCESS"
                [class.text-green-11]="attempt.status === emailAttemptStatus.SUCCESS"
                [class.border]="attempt.status === emailAttemptStatus.SUCCESS"
                [class.border-green-6]="attempt.status === emailAttemptStatus.SUCCESS"
                [class.bg-red-3]="attempt.status === emailAttemptStatus.FAILED"
                [class.text-red-11]="attempt.status === emailAttemptStatus.FAILED"
                [class.border]="attempt.status === emailAttemptStatus.FAILED"
                [class.border-red-6]="attempt.status === emailAttemptStatus.FAILED"
                [class.bg-amber-3]="attempt.status === emailAttemptStatus.PENDING"
                [class.text-amber-11]="attempt.status === emailAttemptStatus.PENDING"
                [class.border]="attempt.status === emailAttemptStatus.PENDING"
                [class.border-amber-6]="attempt.status === emailAttemptStatus.PENDING"
                [class.bg-neutral-3]="attempt.status === emailAttemptStatus.CANCELED"
                [class.text-neutral-11]="attempt.status === emailAttemptStatus.CANCELED"
                [class.border]="attempt.status === emailAttemptStatus.CANCELED"
                [class.border-neutral-6]="attempt.status === emailAttemptStatus.CANCELED"
              >
                <div
                  class="size-1.5 rounded-full"
                  [class.bg-green-9]="attempt.status === emailAttemptStatus.SUCCESS"
                  [class.bg-red-9]="attempt.status === emailAttemptStatus.FAILED"
                  [class.bg-amber-9]="attempt.status === emailAttemptStatus.PENDING"
                  [class.bg-neutral-9]="attempt.status === emailAttemptStatus.CANCELED"
                ></div>
                {{ attempt.status | emailAttemptStatusDisplay }}
              </div>

              <!-- Trigger badge -->
              <div
                class="inline-flex items-center gap-1 rounded-md bg-neutral-a3 px-2 py-0.5 text-xs font-medium text-neutral-11"
              >
                <mat-icon class="text-xs! size-3.5! leading-3.5!">
                  {{
                    attempt.triggered === emailTriggers.DIRECT
                      ? 'bolt'
                      : attempt.triggered === emailTriggers.MANUAL
                        ? 'touch_app'
                        : 'schedule'
                  }}
                </mat-icon>
                <span>{{ attempt.triggered | emailTriggerDisplay }}</span>
              </div>
            </div>

            <!-- Date -->
            <div
              class="flex items-center gap-1.5 text-xs text-neutral-10"
              [matTooltip]="attempt.date | luxonDate: 'humanize'"
            >
              <mat-icon class="text-xs! size-3.5! leading-3.5!">access_time</mat-icon>
              <span>{{ attempt.date | luxonDate: 'dd/LL/yyyy HH:mm:ss' }}</span>
            </div>
          </div>

          <!-- Failure reason if failed -->
          @if (attempt.failureReason) {
            <div
              class="flex items-start gap-2.5 rounded-lg border border-red-6 bg-red-2 p-3 text-sm text-red-11"
            >
              <mat-icon class="text-sm! size-4! shrink-0 text-red-9">error_outline</mat-icon>
              <span class="break-all font-mono text-xs leading-relaxed">{{ attempt.failureReason }}</span>
            </div>
          }

          <!-- Mailer response / Metadata -->
          @if (attempt.metadata) {
            <div class="flex flex-col gap-2">
              <div class="flex items-center gap-1.5 text-xs font-semibold text-neutral-11">
                <mat-icon class="text-xs! size-3.5! leading-3.5! text-neutral-9">terminal</mat-icon>
                <span>
                  {{
                    attempt.metadata['mailerResponse']
                      ? "Réponse du serveur d'envoi (mailerResponse)"
                      : 'Métadonnées'
                  }}
                </span>
              </div>

              <aura-code-block [code]="attempt.metadata['mailerResponse'] ?? attempt.metadata" />
            </div>
          }
        </div>
      }
    }
  </div>
</div>
